import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import PublicWebsiteActions from "../Actions/PublicWebsiteActions";
import publicWebsiteStore from "../Stores/PublicWebsiteStore";
import PublicWebsiteConstants from "../Constants/PublicWebsiteConstants";
import { useGlobalSpinnerActionsContext } from "../Context/GlobalSpinnerContext";
import CustomTextField from "./ReusableComponent/CustomTextField";
import { useLanguageContext } from "../Context/LanguageContext";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import NotListedLocationIcon from "@mui/icons-material/NotListedLocation";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    borderRadius: "12px",
  },
}));

const errorState = {
  duration: false,
  maxOpenTicket: false,
  emailList: false,
  ticketCategories: false,
  emailNotificationInDays: false,
};
export default function ConfigurePublicWebsite(props) {
  const classes = useStyles();
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { equipmentGrpId, setEqtagIssueType, setEqTagIssueList } = props.data;
  const [equimentPropertiesList, setEquimentProperties] = useState([]);
  const [selectedequimentPropertiesList, setSelectedEquimentPropertiesList] =
    useState([]);
  const [equipmentAttributesList, setequipmentAttributes] = useState([]);
  const [selectedEquipmentAttributesList, setSelectedEquipmentAttributesList] =
    useState([]);

  const [duration, setDuration] = useState("");
  const [maxOpenTicket, setMaxOpenTicket] = useState("");
  const [emailList, setEmailList] = useState("");
  const [id, setId] = useState(null);
  const [ticketCategoryList, setTicketCategoryList] = useState("");
  const [emailNotificationThresholdDays, setEmailNotificationThresholdDays] =
    useState("");
  const [checkBoxList, setCheckBoxList] = useState([
    {
      text: localization.checkboxDate,
      value: false,
    },
    {
      text: localization.checkboxPhoto,
      value: false,
    },

    {
      text: localization.checkboxDocument,
      value: false,
    },
    {
      text: localization.checkboxGenerateTicket,
      value: false,
    },
    {
      text: localization.checkboxUser,
      value: true,
    },
    {
      text: localization.checkboxenableInspectionPublically,
      value: false,
    },
    {
      text: localization.photoNeededForTicket,
      value: false,
    },
  ]);
  const [error, setError] = useState(errorState);
  const [errorMsg, setErrorMsg] = useState("");
  const [response, setResponse] = useState(null);

  const overrideStrings = {
    selectSomeItems: localization.select,
    search: localization.search,
    selectAll: localization.select + " " + localization.all,
    selectAllFiltered:
      localization.select +
      " " +
      localization.all +
      "(" +
      localization.filtered +
      ")",
    allItemsAreSelected: localization.allItemSelected,
    noOptions: localization.noOptions,
  };
  const [tagIssueList, setTagIssueList] = useState(null);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const notAllowed = [":", ";", ">", "<", "&", "%", "#", "$"];

  const [inspectionDisplaySetting, setInspectionDisplaySetting] =
    useState("None");
  const [inspectionHistoryLimit, setInspectionHistoryLimit] = useState("");

  useEffect(() => {
    if (!checkBoxList[3].value) {
      setCheckBoxList((prev) => {
        const newList = [...prev];
        newList[4] = { ...newList[4], value: true };
        return newList;
      });
      setDuration("");
      setMaxOpenTicket("");
      setEmailList("");
      setError(errorState);
    }
  }, [checkBoxList[3].value]);

  /* <>--------------------------------------------------------------------Get Configuration Option Start----------------------------------------------------------<> */
  useEffect(() => {
    setGlobalSpinner(true);
    PublicWebsiteActions.getConfigurationOptPublicWebsite(equipmentGrpId);
    function getConfigrationOptionSuccess() {
      let tempMenuList = [];
      let tempAttributeMenuList = [];
      let tempSelMenuList = [];
      let tempSelAttributeMenuList = [];
      var res = publicWebsiteStore.getResult();
      setResponse(res);
      const { configurationData } = { ...res };
      setTagIssueList({
        equipmentDuplicateTag: res["options"]["equipmentDuplicateTag"],
        equipmentmissingTag: res["options"]["equipmentmissingTag"],
      });
      res["options"]["equipmentProperties"].map((row) => {
        tempMenuList.push({ label: row.text, value: row.id });
        if (
          configurationData &&
          configurationData["equipmentProperties"].includes(row.id)
        ) {
          tempSelMenuList.push({ label: row.text, value: row.id });
        }
      });
      res["options"]["equipmentAttributes"].map((row) => {
        tempAttributeMenuList.push({ label: row.text, value: row.id });
        if (
          configurationData &&
          configurationData["equipmentAttributes"].includes(row.id)
        ) {
          tempSelAttributeMenuList.push({ label: row.text, value: row.id });
        }
      });
      if (configurationData) {
        const _temp = [
          configurationData["showCheckDate"],
          configurationData["showCheckPhoto"],
          configurationData["showDocuments"],
          res.canOpenTicket,
          !res.loginRequiredToOpenTicket,
          res.canCreateWebInspection,
          res.isPhotoNeededForTicket,
        ];
        let tempChecklist = [...checkBoxList];
        tempChecklist.map((item, index) => {
          item.value = _temp[index];
        });
        if (res.canOpenTicket) {
          setDuration(res.waitToOpenNewTicketInHours);
          setMaxOpenTicket(res.openTicketLimit);
          setEmailList(
            configurationData.ticketStatusNotificationEmailList.join(",")
          );
          setTicketCategoryList(res.categories != null ? res.categories : "");
          setEmailNotificationThresholdDays(res.emailNotificationThresholdDays);
        }
        setCheckBoxList(tempChecklist);
        setId(res.id);
      }
      if (configurationData) {
        setSelectedEquimentPropertiesList(tempSelMenuList);
        setSelectedEquipmentAttributesList(tempSelAttributeMenuList);
      }
      setEquimentProperties(tempMenuList);
      setequipmentAttributes(tempAttributeMenuList);
      setInspectionDisplaySetting(res.inspectionDisplaySetting);
      setInspectionHistoryLimit(res.inspectionHistoryLimit);
      setGlobalSpinner(false);
    }

    function getConfigrationOptionFailure() {
      setGlobalSpinner(false);
    }

    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_CONFIGURATION_OPTION_SUCCESS,
      getConfigrationOptionSuccess
    );

    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_CONFIGURATION_OPTION_FAILURE,
      getConfigrationOptionFailure
    );
    return () => {
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_CONFIGURATION_OPTION_SUCCESS,
        getConfigrationOptionSuccess
      );

      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_CONFIGURATION_OPTION_FAILURE,
        getConfigrationOptionFailure
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------Get  Configuration Option End----------------------------------------------------------<> */

  /* <>-------------------------------------------------------------------- SaveUpdate configuration option Start----------------------------------------------------------<> */
  useEffect(() => {
    function getConfigrationOptionSuccess() {
      var res = publicWebsiteStore.getResult();
      toast.success(localization.configureSuccess);
      setGlobalSpinner(false);
    }
    function getConfigrationOptionFailure() {
      var res = publicWebsiteStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.SAVE_UPDATE_CONFIGURATION_OPTION_SUCCESS,
      getConfigrationOptionSuccess
    );
    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.SAVE_UPDATE_CONFIGURATION_OPTION_FAILURE,
      getConfigrationOptionFailure
    );
    return () => {
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.SAVE_UPDATE_CONFIGURATION_OPTION_SUCCESS,
        getConfigrationOptionSuccess
      );
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.SAVE_UPDATE_CONFIGURATION_OPTION_FAILURE,
        getConfigrationOptionFailure
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------SaveUpdate configuration option Log End----------------------------------------------------------<> */

  function OnBlurEvent(event) {
    if (
      event.target.id !== "ticketCategories" &&
      !error[event.target.id] &&
      event.target.value === ""
    ) {
      let tempValue = { ...error };
      tempValue[event.target.id] = true;
      setError(tempValue);
    }
  }

  function OnBlurEventEmail(event) {
    let tempValue = { ...error };
    let isTrue = false;
    if (!error[event.target.id] && event.target.value === "") {
      tempValue[event.target.id] = true;
      setError(tempValue);
      setErrorMsg(localization.required);
    } else if (!error[event.target.id]) {
      const _value = event.target.value;

      _value.split(",").map((item) => {
        notAllowed.some((symb) => {
          if (item.includes(symb)) {
            const msg = symb + " " + localization.notValidCharacterError;
            isTrue = true;
            setErrorMsg(msg);
            tempValue[event.target.id] = true;
            setError(tempValue);
            return;
          }
        });
      });
      if (!isTrue) {
        const isInvalid = _value
          .split(",")
          .some((item) => emailRegex.test(item.trim()) === false);
        tempValue[event.target.id] = isInvalid;
        setError(tempValue);
        setErrorMsg(
          tempValue[event.target.id] ? localization.enterValidEmail : ""
        );
      }
    }
  }
  function handleCheckBoxChange(index, value) {
    let _temp = [...checkBoxList];
    _temp[index]["value"] = !value;
    setCheckBoxList(_temp);
  }

  function handleSave(e) {
    e.preventDefault();
    // Validation for inspectionHistoryLimit
    let inspectionHistoryLimitError = false;
    if (inspectionDisplaySetting !== "None") {
      if (
        inspectionHistoryLimit === "" ||
        isNaN(inspectionHistoryLimit) ||
        parseInt(inspectionHistoryLimit) <= 0
      ) {
        inspectionHistoryLimitError = true;
      }
    }
    setError((prev) => ({
      ...prev,
      inspectionHistoryLimit: inspectionHistoryLimitError,
    }));
    if (inspectionHistoryLimitError) {
      return;
    }
    if (Object.keys(error).filter((item) => error[item]).length > 0) {
      setError({
        ...error,
        duration: duration === "" ? true : false,
        maxOpenTicket: maxOpenTicket === "" ? true : false,
        emailNotificationInDays:
          emailNotificationThresholdDays === "" ? true : false,
        inspectionHistoryLimit:
          inspectionDisplaySetting !== "None" &&
          (inspectionHistoryLimit === "" ||
            isNaN(inspectionHistoryLimit) ||
            parseInt(inspectionHistoryLimit) <= 0)
            ? true
            : false,
      });
      return;
    }
    if (
      checkBoxList[3].value &&
      (duration === "" ||
        maxOpenTicket === "" ||
        emailList === "" ||
        emailNotificationThresholdDays == "")
    ) {
      if (emailList === "") {
        setErrorMsg(localization.required);
      }
      setError({
        duration: duration === "" ? true : false,
        maxOpenTicket: maxOpenTicket === "" ? true : false,
        emailList: emailList === "" ? true : false,
        emailNotificationInDays:
          emailNotificationThresholdDays == "" ? true : false,
        inspectionHistoryLimit:
          inspectionDisplaySetting !== "None" &&
          (inspectionHistoryLimit === "" ||
            isNaN(inspectionHistoryLimit) ||
            parseInt(inspectionHistoryLimit) <= 0)
            ? true
            : false,
      });
      return;
    }

    let selectedEquipmentAttribute = [];
    let selectedEquipmentProperty = [];
    if (selectedequimentPropertiesList.length > 0) {
      selectedequimentPropertiesList.map((item) =>
        selectedEquipmentProperty.push(item.value)
      );
    }
    if (selectedEquipmentAttributesList.length > 0) {
      selectedEquipmentAttributesList.map((item) =>
        selectedEquipmentAttribute.push(item.value)
      );
    }
    const configurationObject = {
      EquipmentProperties: selectedEquipmentProperty,
      EquipmentAttributes: selectedEquipmentAttribute,
      TicketStatusNotificationEmailList:
        emailList === "" ? [] : emailList.split(",").map((item) => item.trim()),
      ShowCheckDate: checkBoxList[0].value,
      ShowCheckPhoto: checkBoxList[1].value,
      ShowDocuments: checkBoxList[2].value,
    };
    const _objectData = {
      Id: id,
      AnlagegruppeId: equipmentGrpId,
      CanOpenTicket: checkBoxList[3].value,
      CanCreateWebInspection: checkBoxList[5].value,
      LoginRequiredToOpenTicket: !checkBoxList[4].value,
      IsPhotoNeededForTicket: checkBoxList[6].value,
      OpenTicketLimit: maxOpenTicket === "" ? 0 : parseInt(maxOpenTicket),
      WaitToOpenNewTicketInHours: duration === "" ? 0 : parseInt(duration),
      ConfigurationData: configurationObject,
      Categories: ticketCategoryList.trim(),
      EmailNotificationThresholdDays:
        emailNotificationThresholdDays === ""
          ? 0
          : parseInt(emailNotificationThresholdDays),
      InspectionDisplaySetting: inspectionDisplaySetting,
      InspectionHistoryLimit:
        inspectionDisplaySetting === "None"
          ? 0
          : inspectionHistoryLimit === ""
          ? 0
          : parseInt(inspectionHistoryLimit),
    };
    setGlobalSpinner(true);
    PublicWebsiteActions.saveORupadateConfigurationOption(_objectData);
  }

  //   function RenderDuplicateButton(){
  //  data-toggle="modal"
  //           data-target="#addPruefPlan"
  //   }
  return (
    <>
      {/* <EquipmentTagIssuePopover /> */}
      <div className="h-100">
        <div className="">
          <h2>{localization.publiclyAccessibleHeader}</h2>
        </div>
        {tagIssueList && (
          <div className="d-flex flex-column">
            <span className="mt-3">
              {tagIssueList["equipmentDuplicateTag"].length > 0 &&
              tagIssueList["equipmentmissingTag"].length > 0
                ? localization.labelFormissingDuplicate + localization.canAccess
                : tagIssueList["equipmentmissingTag"].length > 0
                ? localization.labelMissing + localization.canAccess
                : tagIssueList["equipmentDuplicateTag"].length > 0
                ? localization.labelDuplicate + localization.canAccess
                : ""}
            </span>
            <span>
              {tagIssueList["equipmentDuplicateTag"].length > 0 && (
                <Button
                  variant="contained"
                  color="secondary"
                  className="muiButtonConfigPublic mr-4"
                  startIcon={<DynamicFeedIcon />}
                  onClick={() => {
                    setEqTagIssueList(tagIssueList["equipmentDuplicateTag"]);
                    setEqtagIssueType("duplicate");
                  }}
                  data-toggle="modal"
                  data-target="#tagIssue"
                >
                  {localization.duplicateEqButton +
                    " " +
                    countPercentage(
                      response["options"]["equipmentCount"],
                      response["options"]["equipmentDuplicateTagCount"]
                    )}
                </Button>
              )}
              {tagIssueList["equipmentmissingTag"].length > 0 && (
                <Button
                  variant="contained"
                  color="secondary"
                  className="muiButtonConfigPublic"
                  startIcon={<NotListedLocationIcon />}
                  onClick={() => {
                    setEqTagIssueList(tagIssueList["equipmentmissingTag"]);
                    setEqtagIssueType("missing");
                  }}
                  data-toggle="modal"
                  data-target="#tagIssue"
                >
                  {localization.missingEqButton +
                    " " +
                    countPercentage(
                      response["options"]["equipmentCount"],
                      response["options"]["equipmentMissingTagCount"]
                    )}
                </Button>
              )}
            </span>
          </div>
        )}
        <form
          className="pt-5 d-block h-100"
          id="publicWebsiteConfiguration"
          name="publicWebsiteConfiguration"
          onSubmit={handleSave}
        >
          <div className="row w-100 publicWebsiteForm">
            <div className="row mr-0 w-100">
              <div className="col-6 pl-5">
                <div
                  className="form-group w-100 mt-0"
                  // style={{ marginBottom: "3rem" }}
                >
                  <label className="form-label mb-0" htmlFor="Option">
                    {localization.equipmentProperty}
                  </label>
                  <MultiSelect
                    options={equimentPropertiesList}
                    autosize={false}
                    value={selectedequimentPropertiesList}
                    onChange={setSelectedEquimentPropertiesList}
                    labelledBy="Select menu..."
                    closeOnChangedValue={false}
                    overrideStrings={overrideStrings}
                    // className="meltiWidth"
                  />
                </div>
              </div>
              <div className="col-6 pl-5">
                {checkBoxList[3].value && (
                  <div className="form-group w-100">
                    <CustomTextField
                      type="number"
                      autoFocusElement={false}
                      requried={true}
                      id="maxOpenTicket"
                      label={localization.maxopenticket}
                      value={maxOpenTicket}
                      OnBlurEvent={OnBlurEvent}
                      onChange={setMaxOpenTicket}
                      error={error["maxOpenTicket"]}
                      disabled={false}
                      required={false}
                      placeHolder={""}
                      errorHandle={setError}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="row mr-0 w-100">
              <div className="col-6 pl-5 publicWebCol">
                <div className="form-group w-100">
                  <label
                    className="form-label mb-0"
                    htmlFor="equipmentAttributes"
                  >
                    {localization.equipmentAttributes}
                  </label>
                  <MultiSelect
                    options={equipmentAttributesList}
                    autosize={false}
                    value={selectedEquipmentAttributesList}
                    onChange={setSelectedEquipmentAttributesList}
                    labelledBy="Select menu..."
                    closeOnChangedValue={false}
                    overrideStrings={overrideStrings}
                    // className="meltiWidth"
                  />
                </div>
              </div>
              <div className="col-6 pl-5">
                {checkBoxList[3].value && (
                  <div className="form-group w-100 customizeFormField">
                    <CustomTextField
                      type="number"
                      requried={true}
                      autoFocusElement={false}
                      id="duration"
                      label={
                        localization.durationbetweenTicket +
                        "(" +
                        localization.inhour +
                        ")"
                      }
                      value={duration}
                      OnBlurEvent={OnBlurEvent}
                      onChange={setDuration}
                      error={error["duration"]}
                      placeHolder={localization.maxWindowSize}
                      disabled={false}
                      required={false}
                      errorHandle={setError}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="row mr-0 w-100">
              <div className="col-6 pl-5">
                {checkBoxList.map((item, index) => {
                  if (index === 4 || index === 6) {
                    if (checkBoxList[3].value) {
                      return (
                        <div className="form-group w-100 d-flex" key={index}>
                          <div className="col pl-0">
                            <label className=" form-label" htmlFor="Option">
                              {item.text}
                            </label>
                          </div>
                          <div className="col-2 text-right pr-0">
                            <input
                              type="checkbox"
                              name={index}
                              checked={item.value}
                              onChange={(e) => {
                                handleCheckBoxChange(index, item.value);
                              }}
                            />
                          </div>
                        </div>
                      );
                    }
                  } else {
                    return (
                      <div className="form-group w-100 d-flex" key={index}>
                        <div className="col pl-0">
                          <label className=" form-label" htmlFor="Option">
                            {item.text}
                          </label>
                        </div>
                        <div className="col-2 text-right pr-0">
                          <input
                            type="checkbox"
                            name={index}
                            checked={item.value}
                            onChange={(e) => {
                              handleCheckBoxChange(index, item.value);
                            }}
                          />
                        </div>
                      </div>
                    );
                  }
                })}
                {/* Dropdown for inspection display setting, placed after all checkboxes */}
                <div className="form-group w-100 mt-4">
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel
                      id="inspectionDisplaySetting-label"
                      className="inspection-label"
                      style={{ zIndex: 0 }}
                    >
                      {localization.inspectionConfiguration}
                    </InputLabel>
                    <Select
                      labelId="inspectionDisplaySetting-label"
                      id="inspectionDisplaySetting"
                      value={inspectionDisplaySetting}
                      onChange={(e) => {
                        const value = e.target.value;
                        setInspectionDisplaySetting(value);
                        if (value === "None") {
                          setInspectionHistoryLimit(0);
                        }
                      }}
                      label={localization.inspectionConfiguration}
                    >
                      <MenuItem value="None">
                        {localization.noInspectionAtAll}
                      </MenuItem>
                      <MenuItem value="DatesAndResultOnly">
                        {localization.onlyDateAndResult}
                      </MenuItem>
                      <MenuItem value="QuestionsAndAnswers">
                        {localization.dateResQuestionAndAns}
                      </MenuItem>
                      <MenuItem value="FullDetails">
                        {localization.fullInspectionDetails}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
                {/* Input for number of past inspections to show */}
                <div className="form-group w-100 mt-4">
                  <CustomTextField
                    type="number"
                    autoFocusElement={false}
                    requried={true}
                    id="inspectionHistoryLimit"
                    label={localization.numberOfPastInspections}
                    value={inspectionHistoryLimit}
                    OnBlurEvent={OnBlurEvent}
                    onChange={setInspectionHistoryLimit}
                    error={error["inspectionHistoryLimit"]}
                    disabled={inspectionDisplaySetting == "None"}
                    required={false}
                    placeHolder={""}
                    errorHandle={setError}
                  />
                </div>
              </div>
              <div className="col-6 pl-5">
                {checkBoxList[3].value && (
                  <>
                    <div className="form-group w-100">
                      <CustomTextField
                        type="multiline"
                        requried={true}
                        autoFocusElement={false}
                        id="emailList"
                        label={localization.ticketRecepientsEmail}
                        value={emailList}
                        OnBlurEvent={OnBlurEventEmail}
                        onChange={setEmailList}
                        error={error["emailList"]}
                        disabled={false}
                        required={false}
                        errorHandle={setError}
                        errorMsg={errorMsg}
                        // isEmail={true}
                        placeHolder={localization.placeholderEmail}
                      />
                    </div>

                    <div className="form-group w-100">
                      <CustomTextField
                        type="text"
                        autoFocusElement={false}
                        requried={true}
                        id="ticketCategories"
                        label={localization.ticketCategories}
                        value={ticketCategoryList}
                        // OnBlurEvent={OnBlurEvent}
                        onChange={setTicketCategoryList}
                        error={error["ticketCategories"]}
                        disabled={false}
                        required={false}
                        placeHolder={""}
                        errorHandle={setError}
                      />
                    </div>

                    <div className="form-group w-100">
                      <CustomTextField
                        type="number"
                        autoFocusElement={false}
                        requried={true}
                        id="emailNotificationInDays"
                        label={localization.emailNotificationTimeframe}
                        value={emailNotificationThresholdDays}
                        OnBlurEvent={OnBlurEvent}
                        onChange={setEmailNotificationThresholdDays}
                        error={error["emailNotificationInDays"]}
                        disabled={false}
                        required={false}
                        placeHolder={""}
                        errorHandle={setError}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="row w-100 justify-content-center mt-3">
            <button type="submit" className="btn btn-primary mr-2 mb-4 ">
              {localization.save}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

function countPercentage(_total, _current) {
  return (
    _current +
    "/" +
    _total +
    " " +
    "(" +
    ((_current / _total) * 100).toFixed(0) +
    "%)"
  );
}
